import { __privateAdd, __privateMethod, Popover, waitForEvent } from "theme";

var _onCompareChange, onCompareChange_fn;
var ComparePopover = class extends Popover {
  constructor() {
    super();
    __privateAdd(this, _onCompareChange);
    this.addEventListener("listbox:change", __privateMethod(this, _onCompareChange, onCompareChange_fn));
  }
};

_onCompareChange = new WeakSet();
onCompareChange_fn = async function(event) {
	let parentElementId = event.target.closest('.popover').id;
	
	await waitForEvent(this, "dialog:after-hide");
	
	Array.from(document.querySelectorAll('[aria-controls="' + parentElementId + '"]')).forEach(function (item) {
		item.dispatchEvent(new CustomEvent("compare:update", {
			bubbles: true,
			detail: {
				value: event.detail.value,
				target: event.target
			}
		}));
	});
};

if (!window.customElements.get("compare-popover")) {
  window.customElements.define("compare-popover", ComparePopover);
}

var CompareGHD = class extends HTMLElement {
	constructor() {
		super();
        this.addEventListener('compare:update', this._updateCompareProduct.bind(this));
		this.addEventListener('quiz:result', this._quizResult.bind(this));
	}
  
	connectedCallback() {
		this.compareItem_1 = {
			handle: this.querySelector('[data-active-column="1"]').getAttribute('data-product-handle'),
			title: this.querySelector('[data-active-column="1"]').getAttribute('data-product-title')
		};
		this.compareItem_2 = {
			handle: this.querySelector('[data-active-column="2"]').getAttribute('data-product-handle'),
			title: this.querySelector('[data-active-column="2"]').getAttribute('data-product-title')
		};
		this.compareItem_3 = {
			handle: this.querySelector('[data-active-column="3"]').getAttribute('data-product-handle'),
			title: this.querySelector('[data-active-column="3"]').getAttribute('data-product-title')
		};
	  
		if (this.desktopItemCount == 4 && this.querySelector('[data-active-column="4"]')) {
			this.compareItem_4 = {
				handle: this.querySelector('[data-active-column="4"]').getAttribute('data-product-handle'),
				title: this.querySelector('[data-active-column="4"]').getAttribute('data-product-title')
			};
		}
	}
  
	disconnectedCallback() {
	  
	}
  
	get desktopItemCount() {
		return this.getAttribute('desktop-item-count');
	}
	
	_quizResult(event) {
		const _this = this;		
		event.detail.scoreTotals.every(function (item, index) {
			if (index < _this.desktopItemCount) {
				let compareColumn = index + 1;
				let compareValue = item[0];
				let compareTitle = item[2];
				_this._updateCompareProduct(event, compareColumn, compareValue, compareTitle);
				return true
			} else {
				return false;
			}
		});
	}
	
	_updateCompareProduct(event, compareColumn, compareValue, compareTitle) {
		if (event.type != 'quiz:result') {
			let target = event.detail.target;
			compareColumn = target.getAttribute('data-compare-column');
			compareValue = event.detail.value;
			compareTitle = target.querySelector('span').innerText;
		}

		if (this.compareItem_1.handle == compareValue) {
			this.compareItem_1 = this['compareItem_' + compareColumn];
		} else if (this.compareItem_2.handle == compareValue) {
			this.compareItem_2 = this['compareItem_' + compareColumn];
		} else if (this.compareItem_3.handle == compareValue) {
			this.compareItem_3 = this['compareItem_' + compareColumn];
		} else if (this.desktopItemCount == 4 && this.compareItem_4.handle == compareValue) {
			this.compareItem_4 = this['compareItem_' + compareColumn];
		}
		
		this['compareItem_' + compareColumn] = {
			handle: compareValue,
			title: compareTitle
		};
		
		this.querySelectorAll('.compare-header .cell')[0].querySelector('button span').innerHTML = this.compareItem_1.title;
		this.querySelectorAll('.compare-header .cell')[1].querySelector('button span').innerHTML = this.compareItem_2.title;
		this.querySelectorAll('.compare-header .cell')[2].querySelector('button span').innerHTML = this.compareItem_3.title;
		if (this.desktopItemCount == 4) {
			this.querySelectorAll('.compare-header .cell')[3].querySelector('button span').innerHTML = this.compareItem_4.title;
		}

		// Hide Current Selected Item for Column
		Array.from(this.querySelectorAll('[data-active-column="1"]')).forEach(function (item) {
			item.style.display = 'none';
			item.removeAttribute('data-active-column');
		});
		
		Array.from(this.querySelectorAll('[data-active-column="2"]')).forEach(function (item) {
			item.style.display = 'none';
			item.removeAttribute('data-active-column');
		});
		
		Array.from(this.querySelectorAll('[data-active-column="3"]')).forEach(function (item) {
			item.style.display = 'none';
			item.removeAttribute('data-active-column');
		});
		
		if (this.desktopItemCount == 4) {
			Array.from(this.querySelectorAll('[data-active-column="4"]')).forEach(function (item) {
				item.style.display = 'none';
				item.removeAttribute('data-active-column');
			});
		}
		
	  
		// Show New Selected Item for Column
		Array.from(this.querySelectorAll('[data-product-handle="' + this.compareItem_1.handle + '"]')).forEach(function (item) {
			item.style.display = 'block';
			item.setAttribute('data-active-column', '1');
		});
		
		Array.from(this.querySelectorAll('[data-product-handle="' + this.compareItem_2.handle + '"]')).forEach(function (item) {
			item.style.display = 'block';
			item.setAttribute('data-active-column', '2');
		});
		
		Array.from(this.querySelectorAll('[data-product-handle="' + this.compareItem_3.handle + '"]')).forEach(function (item) {
			item.style.display = 'block';
			item.setAttribute('data-active-column', '3');
		});
		
		if (this.desktopItemCount == 4) {
			Array.from(this.querySelectorAll('[data-product-handle="' + this.compareItem_4.handle + '"]')).forEach(function (item) {
				item.style.display = 'block';
				item.setAttribute('data-active-column', '4');
			});
		}
		
		
		// Labels
	  
		// Hide all item selectors
		Array.from(this.querySelectorAll('.popover__value-list button')).forEach(function (item) {
			item.querySelector('.link-label').setAttribute('hidden', 'hidden');
		});
	  
		// Show active item selectors
		Array.from(this.querySelectorAll('.popover__value-list button[data-value="' + this.compareItem_1.handle + '"]')).forEach(function (item) {
			item.querySelector('.link-label').removeAttribute('hidden');
		});
		Array.from(this.querySelectorAll('.popover__value-list button[data-value="' + this.compareItem_2.handle + '"]')).forEach(function (item) {
			item.querySelector('.link-label').removeAttribute('hidden');
		});
		Array.from(this.querySelectorAll('.popover__value-list button[data-value="' + this.compareItem_3.handle + '"]')).forEach(function (item) {
			item.querySelector('.link-label').removeAttribute('hidden');
		});
	  
		if (this.desktopItemCount == 4) {
			Array.from(this.querySelectorAll('.popover__value-list button[data-value="' + this.compareItem_4.handle + '"]')).forEach(function (item) {
				item.querySelector('.link-label').removeAttribute('hidden');
			});
		}
	}
  
};

if (!window.customElements.get("compare-ghd")) {
  window.customElements.define("compare-ghd", CompareGHD);
}

export {
	CompareGHD
}